module.exports = __webpack_public_path__ + "static/media/forks_history_bitcoin-studio.e57da819.jpg";